import { IUser } from '@novakid/ts-types';

const toBase64 = (str: string) => {
  const encoder = new TextEncoder();
  const byteArray = encoder.encode(str);

  return window.btoa(String.fromCharCode(...byteArray));
};

export function getSignUpToken(user: IUser, token: string) {
  return encodeURIComponent(toBase64(JSON.stringify({
    formData: { parentName: user.name, email: user.email, phone: user.phone },
    currentRegion: { code: user.region_code },
    other: { refPage: "SIGNIN_PAGE" },
    region_code: user.region_code,
    ga_user_id: user.ga_user_id,
    teacherBookingParams: {},
    parentName: user.name,
    eula_accepted: true,
    auth_token: token,
    email: user.email,
    phone: user.phone,
    user_id: user.id,
  })));
}